import moment from "moment";
import Icon from "../../../components/atoms/Icon";
import { useContext, useEffect, useState } from "react";
import { MapContext } from "../RetailLocation";
import { getQueuesAPI } from "../../../util";
import AuthContext from "../../../contexts/auth-context";

export default function ZoneItem({
  x,
  data,
  currentLocation,
  currentSeries,
  currentGame,
  dayType,
  className,
  zoneLabels,
  setZoneLabels,
}) {
  const authCtx = useContext(AuthContext);
  const [showMap, setShowMap] = useState(false);
  const [showAllMaps] = useContext(MapContext);
  const [, setShowEdit] = useState(false);
  const [, setEditing] = useState(false);
  const [label, setLabel] = useState("");
  const [saved, setSaved] = useState(false);

  // Get the location ID from currentLocation
  const locationId = currentLocation.id.toString()

  // Check if current user is admin for this location
  const isAdmin = (authCtx.authLocations || []).some(
    loc => loc.locationId === currentLocation.id && loc.isAdmin === true
  );

  const onChangeLabel = (e) => {
    setLabel(e.target.value);
  };

  const handleBlur = (e) => {
    onBlurLabel(e);
    setShowEdit(false);
    setEditing(false);
  };

  const onBlurLabel = (e) => {
    let newLabel = e.target.value.trim();
    const currentLabel = findLabelByZoneId(x.zoneId);

    // Empty → revert to what it was, no save
    if (newLabel === "") {
      setLabel(currentLabel);
      return;
    }

    // Enforce max length
    if (newLabel.length > 25) {
      newLabel = newLabel.substring(0, 25);
      setLabel(newLabel);
    }

    // Skip API call if label hasn't changed
    if (newLabel === currentLabel) return;

    saveZoneLabel(newLabel, x.zoneId);
  };

  // Re-initialize label when shared zoneLabels state changes
  useEffect(() => {
    setLabel(findLabelByZoneId(x.zoneId));
  }, [zoneLabels]);

  useEffect(() => {
    setShowMap(showAllMaps);
  }, [showAllMaps]);

  // Finds the zone label: checks shared zoneLabels prop first, falls back to defaultZoneLabel
  const findLabelByZoneId = (zoneId) => {
    const labels = zoneLabels || {};
    const label = labels[String(zoneId)];
    if (label) return label;

    return currentLocation.defaultZoneLabel;
  };

  // Saves the zone label to the locations collection via API
  const saveZoneLabel = (newLabel, zId) => {
    getQueuesAPI(
      "retail-location-update-zone-label",
      {
        measurement: currentLocation.measurement,
        venue: authCtx.venue,
        locationId: currentLocation.id,
        zoneId: zId,
        label: newLabel,
      },
      (data, error) => {
        if (error) {
          console.error("Error updating zone label");
        } else {
          // Update shared zoneLabels state so all components see the new label
          if (setZoneLabels) {
            setZoneLabels(prev => ({ ...prev, [String(zId)]: newLabel }));
          }
          setSaved(true);
          setTimeout(() => setSaved(false), 750);
        }
      },
      authCtx.token
    );
  };

  const hasData = x.peak.traffic !== -Infinity;

  return (
    <div className="rx-zitem cx-fade-in">
      <div className="rx-zitem-head">
        <span className="rx-zitem-id">Zone {x.zoneId}</span>
        {saved && (
          <span className="rx-zitem-saved">
            <Icon name="check-circle-fill" /> Saved
          </span>
        )}
      </div>
      {isAdmin ? (
        <input
          className="rx-zitem-input"
          value={label}
          onChange={onChangeLabel}
          onBlur={handleBlur}
          maxLength={25}
          aria-label={`Name for zone ${x.zoneId}`}
          title="Rename this zone"
        />
      ) : (
        <div className="rx-zitem-label">{label}</div>
      )}
      {hasData ? (
        <div className="rx-zitem-stats">
          <div>
            <div className="cx-tile-detail-label">Now</div>
            <div className="cx-tile-detail-value">{data}</div>
          </div>
          {x.peak && x.peak.traffic >= 0 && (
            <div>
              <div className="cx-tile-detail-label">Peak</div>
              <div className="cx-tile-detail-value">{x.peak.traffic}</div>
              <div className="cx-tile-detail-at">at {moment(x.peak.time2).format("LT")}</div>
            </div>
          )}
        </div>
      ) : (
        <div className="rx-zitem-empty">
          <Icon name="exclamation-diamond" /> No data available
        </div>
      )}
    </div>
  );
}